import React, { useEffect } from "react";
import { useParams } from "react-router";

import { useContents } from "fond/hooks/useContents";
import { BaseProjectList } from "fond/projects/BaseProjectList";
import { clearSharedAccount, updateSharedAccount } from "fond/projects/redux";
import { useAppDispatch } from "fond/utils/hooks";

/**
 * A filterable list of projects displayed to the user within a DataGrid including Column Sorting and Pagination
 */
const SharedContentList: React.FC = () => {
  const { sharedItems } = useContents();
  const dispatch = useAppDispatch();

  const { account: selectedAccount } = useParams();

  useEffect(() => {
    // if entering the page manually, we want to update store
    if (selectedAccount) {
      dispatch(updateSharedAccount(selectedAccount));
    } else {
      dispatch(clearSharedAccount);
    }
  }, [dispatch, selectedAccount]);

  const filteredItems = selectedAccount ? sharedItems.filter((item) => item.Account.ID === selectedAccount) : sharedItems;

  return <BaseProjectList items={filteredItems} />;
};

export default SharedContentList;
